import { EmailTemplatePreview } from "../../email-templates/components/EmailTemplatePreview";

export const EmailTemplateLayoutPreview = EmailTemplatePreview;
